
const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold mb-6">
          Ready to Take Your Business Global?
        </h2>
        <p className="text-xl text-teal-100 mb-8 max-w-3xl mx-auto">
          Join hundreds of successful businesses that have expanded internationally with our proven strategies. 
          Your next customers are waiting in markets you haven't reached yet.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button className="bg-white text-teal-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap">
            Book Free Strategy Call
          </button>
          <button className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap">
            Download Global Readiness Checklist
          </button>
        </div>
        
        <div className="mt-8 text-sm text-teal-100">
          <p>✓ No commitment required  ✓ 30-minute consultation  ✓ Customized recommendations</p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
